import Api from '../api';

class RuleAlertService {
  async getAllAssets() {
    try {
        let url = '/asset/all_assets'
        let response = await Api.get(url)

        return response.data;
    } catch (err) {
      console.error("Error in getAllAssets:", err);
      return [];
    }
  };

  async getAllRulesByAsset(assetId: string) {
    try {
        let url = `/asset/all_rules?asset_id=${assetId}`
        let response = await Api.get(url)

        return response.data;
    } catch (err) {
      console.error("Error in getAllRulesByAsset:", err);
      return [];
    }
  };

  async getAllAlerts(assetId: string) {
    try {
        let url = `/rules/all_alerts${assetId}`
        let response = await Api.get(url)

        return response.data;
    } catch (err) {
      console.error("Error in getAllAlerts:", err);
      return [];
    }
  };

  async getAllAssetTypes() {
    try {
        let url = `/asset_types`
        let response = await Api.get(url)

        return response.data;
    } catch (err) {
      console.error("Error in getAllAssetTypes:", err);
      return [];
    }
  };

  async deleteRuleAlert(alertId: string) {
    try {
        let url = `/rules/alert/${alertId}`
        let response = await Api.delete(url)

        return response.data;
    } catch (err) {
      console.error("Error in deleteRuleAlert:", err);
      return [];
    }
  };

  async checkRulesStatusForAssets(assetIds: string[]) {
    try {
        let url = '/asset/rules-status'
        let response = await Api.post(url, { asset_ids: assetIds })

        return response.data?.rulesStatus || {};
    } catch (err) {
      console.error("Error in checkRulesStatusForAssets:", err);
      return {};
    }
  };

}

export default new RuleAlertService()